import { render } from "./customers-login.vue?vue&type=template&id=c2023546"
import script from "./customers-login.vue?vue&type=script&lang=js"
export * from "./customers-login.vue?vue&type=script&lang=js"

import "./customers-login.vue?vue&type=style&index=0&id=c2023546&lang=scss"

import exportComponent from "/Users/ashley.eastham/Fostr Dev/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__